import React from 'react'
function NotFound() {

  return (
    <div className='mc-page not-found slow_ani'>
      NotFound
    </div>
  )
}
export default NotFound